require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-tags-downtown-indy-post-office-branch.json") })
        }
      }, "path---es-articles-tags-downtown-indy-post-office-branch");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-tags-downtown-indy-post-office-branch!./.cache/json/es-articles-tags-downtown-indy-post-office-branch.json
// module id = 2313
// module chunks = 231608221292675